(function () {
    var form = document.getElementById('VgCommentForm');
    if (!form) return;
    var container = form.closest('[data-vg-comments]');
    var requireRating = container ? container.getAttribute('data-require-rating') === 'true' : false;
    var enableRating = container ? container.getAttribute('data-enable-rating') === 'true' : true;
 
    form.addEventListener('submit', function (e) {
      if (!enableRating) return;
      var checked = form.querySelector('input[name="vg_rating"]:checked');
      var err = document.getElementById('VgRatingError');
 
      if (!checked) {
        if (requireRating) {
          e.preventDefault();
          if (err) err.hidden = false;
          document.getElementById('VgRating').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      if (err) err.hidden = true;
 
      var r = parseInt(checked.value, 10);
      var stars = '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r);
      var body = document.getElementById('CommentBody');
      if (body && body.value.slice(0, 1) !== '★') {
        body.value = stars + ' ' + body.value;
      }
    });
  })();